import(/* webpackMode: "eager", webpackExports: ["MDXContent"] */ "/vercel/path0/components/MDXContent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
